<template>
  <NuxtLink :to="`/${locale}`" class="logo">
    <img
      v-if="locale === 'uk'"
      :src="config.site?.logo ?? '/images/logo/logo.svg'"
      :alt="config.site?.orgName ?? 'Школа Біблії'"
      class="logo-img"
    />
    <img
      v-else
      src="/icons/new-logo.svg"
      :alt="config.site?.orgName ?? 'Школа Біблії'"
      class="logo-img"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
const { locale } = useI18n()
const config = useAppConfig()
</script>

<style scoped>
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  max-width: 131px;
}

.logo-img {
  display: block;
  width: 203px;
  height: auto;
}

@media (max-width: 480px) {
  .logo-img {
    width: 80px;
  }
}
</style>
